<article>
  <header>
    <strong>TMA x Non-Talk</strong>
    <div class="sub-title">por segmento</div>
  </header>
  <main>
    <app-pie-chart [loading]="isLoading" [error]="error"></app-pie-chart>
  </main>
</article>
